module.exports = __webpack_public_path__ + "img/signup-payment-icon.529b9cf2.svg";